import styled from 'styled-components';

export const BoostCardPlaceholder = styled.div`
  width: 300px;
  height: 461px;
  background: #100418;
  background-image: linear-gradient(to right, #100418 0%, #1a1328 20%, #100418 40%, #100418 100%);
  background-repeat: no-repeat;
  background-size: 100% 461px;
  border-radius: 8px;
  display: inline-block;
  animation: boostCardShimmer 0.75s forwards linear infinite;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  @keyframes boostCardShimmer {
    0% {
      background-position: -300px 0;
    }
    100% {
      background-position: 300px 0;
    }
  }
`;
